/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateKeyPolicyRequestBody,
  UpdateKeyPolicyRequestBody$Outbound,
  UpdateKeyPolicyRequestBody$outboundSchema,
} from "../components/updatekeypolicyrequestbody.js";

export type UpdateAPIKeyPolicySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateAPIKeyPolicyRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateKeyPolicyRequestBody: UpdateKeyPolicyRequestBody;
};

/** @internal */
export type UpdateAPIKeyPolicySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateAPIKeyPolicySecurity$outboundSchema: z.ZodMiniType<
  UpdateAPIKeyPolicySecurity$Outbound,
  UpdateAPIKeyPolicySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateAPIKeyPolicySecurityToJSON(
  updateAPIKeyPolicySecurity: UpdateAPIKeyPolicySecurity,
): string {
  return JSON.stringify(
    UpdateAPIKeyPolicySecurity$outboundSchema.parse(updateAPIKeyPolicySecurity),
  );
}

/** @internal */
export type UpdateAPIKeyPolicyRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateKeyPolicyRequestBody: UpdateKeyPolicyRequestBody$Outbound;
};

/** @internal */
export const UpdateAPIKeyPolicyRequest$outboundSchema: z.ZodMiniType<
  UpdateAPIKeyPolicyRequest$Outbound,
  UpdateAPIKeyPolicyRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    updateKeyPolicyRequestBody: UpdateKeyPolicyRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      updateKeyPolicyRequestBody: "UpdateKeyPolicyRequestBody",
    });
  }),
);

export function updateAPIKeyPolicyRequestToJSON(
  updateAPIKeyPolicyRequest: UpdateAPIKeyPolicyRequest,
): string {
  return JSON.stringify(
    UpdateAPIKeyPolicyRequest$outboundSchema.parse(updateAPIKeyPolicyRequest),
  );
}
